import React from "react";

interface Props {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  hover?: boolean;
}

const GlassCard: React.FC<Props> = ({ children, className = "", onClick, hover = false, }) => (
  <div
    onClick={onClick}
    className={`rounded-2xl border border-white/20 shadow-xl
      ${onClick || hover ? "cursor-pointer hover:shadow-2xl hover:-translate-y-0.5 transition-all duration-200" : ""}
      ${className}`}
    style={{
      background: "rgba(255,255,255,0.55)",
      backdropFilter: "blur(16px)",
      WebkitBackdropFilter: "blur(16px)",
    }}
  >
    {children}
  </div>
);

export default GlassCard;
